<ng-container *ngIf="boxes">
    <div class="box" *ngFor="let box of boxes | sortBy:'order'" [ngClass]="box.generalClass">
        <div class="prompt">{{box.boxId | translate}} <i class="fa fa-info-circle" aria-hidden="true"
                *ngIf="box.helpResource" matTooltip="{{ box.helpResource | translate }}"></i></div>
        <div class="value only-valueInt"> {{box.valueInt}}</div>
        <div class="value only-valueString"> {{box.valueString}}</div>
        <div class="value only-valueHTime"> {{box.valueHTime | time}}</div>
        <div class="value only-valueDouble"> {{box.valueDouble}}</div>
        <div class="value only-valuePercentage"> {{box.valueDouble | percentage}}</div>
    </div>
</ng-container>